import {
  Box,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  styled,
} from "@mui/material";
import { useState } from "react";

import { KeyboardArrowDown, KeyboardArrowUp } from "components/Icons";

const CollapseClicker = styled(Box)(() => ({
  color: "#1A1C1F",
  fontSize: "14px",
  display: "flex",
  alignItems: "center",
}));

const BodyTableRow = styled(TableRow)(({ open }) => ({
  "& .MuiTableCell-root": {
    borderBottom: "none",
  },
}));

export const EXPAND_DETAILS_COLUMN = {
  field: "@More:Details",
  headerName: "",
  renderCell: (row, { open, toggle } = {}) => {
    return (
      <IconButton
        disableRipple={true}
        aria-label="expand row"
        size="small"
        onClick={toggle}
      >
        {open ? (
          <CollapseClicker>
            Collapse
            <KeyboardArrowUp />
          </CollapseClicker>
        ) : (
          <CollapseClicker>
            View Details
            <KeyboardArrowDown />
          </CollapseClicker>
        )}
      </IconButton>
    );
  },
};

const DefaultDetails = () => {
  return <div />;
};

export function CustomTableRow({ columns, row, expandableRowComponent }) {
  const [open, setOpen] = useState(false);
  const [hovering, setHovering] = useState(true);
  const DetailsComponent = expandableRowComponent ?? DefaultDetails;
  return (
    <>
      <BodyTableRow
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        hover={false}
        sx={{
          py: 2,
          ...(hovering && {
            background: "rgba(0, 0, 0, 0.04)",
            "& + .row_details": {
              background: "rgba(0, 0, 0, 0.04)",
            },
          }),
        }}
      >
        {columns.map((column, i) => {
          if (column.field === EXPAND_DETAILS_COLUMN.field) {
            return (
              <TableCell
                key={column.field}
                align={column.align}
                width={column.width}
              >
                {column.renderCell(row, {
                  open,
                  toggle: () => setOpen((prev) => !prev),
                })}
              </TableCell>
            );
          } else {
            const value = row[column.field] ? row[column.field] : null;
            return (
              <TableCell
                key={column.field}
                align={column.align}
                width={column.width}
              >
                {column.renderCell ? column.renderCell(row, i) : value}
              </TableCell>
            );
          }
        })}
      </BodyTableRow>
      <TableRow
        hover={false}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        className="row_details"
      >
        <TableCell style={{ padding: 0 }} colSpan={columns.length}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{
                paddingTop: 1,
                padding: "0px 16px",
              }}
            >
              <DetailsComponent row={row} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
